import { Link } from "react-router-dom";
import "./App.css";

const EMAIL = "hello.zubo@gmail.com";

function LegalLayout({ title, children }) {
  return (
    <div className="zubo App">
      <header className="legal-head">
        <div className="wrap legal-head-inner">
          <Link to="/" className="legal-brand" data-testid="legal-home-link">ZUBO™</Link>
          <Link to="/" className="legal-back" data-testid="legal-back-link">← Zurück zur Startseite</Link>
        </div>
      </header>
      <main className="legal">
        <div className="wrap">
          <h1 data-testid="legal-title">{title}</h1>
          {children}
        </div>
      </main>
      <footer>
        <div className="wrap">
          <p style={{ fontSize: "13px" }}>© {new Date().getFullYear()} ZUBO™ · Dr. med. dent. Neda Trivić</p>
          <p style={{ fontSize: "13px" }}>
            <Link to="/impressum">Impressum</Link> · <Link to="/datenschutz">Datenschutz</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}

export function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <p>Dr. med. dent. Neda Trivić</p>
      <p>Kapitelgasse 9/1, 5020 Salzburg, Österreich</p>
      <p>E-Mail: <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
      <p>Unternehmensgegenstand: Entwicklung und Vertrieb von Kinder-Zahnputzprodukten unter der Marke ZUBO™</p>
      <p>Gewerbe: Handelsgewerbe mit Ausnahme der reglementierten Handelsgewerbe (freies Gewerbe)</p>
      <p>GISA-Zahl: 39360489</p>
      <p>Gewerbebehörde: Magistrat der Stadt Salzburg</p>
      <p>Mitglied der Wirtschaftskammer Salzburg</p>
      <p>
        Rechtsvorschrift: Gewerbeordnung, abrufbar unter{" "}
        <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer">www.ris.bka.gv.at</a>
      </p>
      <p className="legal-updated">© 2026 ZUBO™. Alle Rechte vorbehalten.</p>
    </LegalLayout>
  );
}

export function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <p>
        <strong>Verantwortlich:</strong> Dr. med. dent. Neda Trivić, Kapitelgasse 9/1, 5020 Salzburg,{" "}
        <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
      </p>

      <p>
        <strong>Formulare:</strong> Wenn Sie ein Formular ausfüllen, speichern wir Ihre E-Mail-Adresse und
        Ihre Angaben, um Ihnen zu antworten und Sie über ZUBO™ zu informieren. Grundlage ist Ihre Einwilligung
        (Art. 6 Abs. 1 lit. a DSGVO), die Sie jederzeit per E-Mail widerrufen können. Wir löschen die Daten,
        sobald wir sie nicht mehr brauchen, spätestens nach 24 Monaten.
      </p>

      <p>
        <strong>Website-Betrieb:</strong> Beim Aufruf der Website werden technisch notwendige Daten
        (z. B. IP-Adresse) verarbeitet (Art. 6 Abs. 1 lit. f DSGVO). Unsere Dienstleister sind Emergent
        (Hosting), Cloudflare (Auslieferung der Website) und Google (E-Mail). Dabei können Daten in die USA
        übermittelt werden, auf Grundlage des EU-US Data Privacy Framework bzw. von EU-Standardvertragsklauseln.
      </p>

      <p>
        <strong>Cookies:</strong> Wir verwenden keine Tracking- oder Werbe-Cookies.
      </p>

      <p>
        <strong>Ihre Rechte:</strong> Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung,
        Datenübertragbarkeit und Widerspruch. Beschwerden können Sie an die Österreichische Datenschutzbehörde
        richten (<a href="https://www.dsb.gv.at" target="_blank" rel="noopener noreferrer">www.dsb.gv.at</a>).
      </p>
    </LegalLayout>
  );
}
